import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from "./logo.png";
import {
  AiOutlineProfile, AiFillLock
} from "react-icons/ai";
import {
  LiaSellsy
} from "react-icons/lia";
import {
  MdDashboard, MdOutlineLeaderboard, MdOutlineLanguage, MdTaskAlt, MdOutlineShoppingBag, MdCategory,
  MdOutlineInventory, MdSupportAgent, MdGroupWork, MdOutlinePendingActions, MdOutlineVerifiedUser,
  MdHistory, MdOutlineFeedback, MdLocationPin, MdCardMembership, MdCabin
} from "react-icons/md";
import {
  IoNewspaperOutline, IoSettingsOutline, IoPaperPlaneOutline
} from "react-icons/io5";
import {
  FaUsers, FaRegUser, FaLink
} from "react-icons/fa";
import {
  GrDocumentConfig, GrCurrency
} from "react-icons/gr";
import {
  RiShieldUserFill, RiOrganizationChart, RiUserStarLine
} from 'react-icons/ri';
import {
  VscFileSubmodule, VscChecklist
} from "react-icons/vsc";
import {
  GoUnverified
} from "react-icons/go";
import {
  BsClipboard2
} from "react-icons/bs";
import {
  PiNotebookLight
} from "react-icons/pi";
import {
  CiBadgeDollar
} from "react-icons/ci";
import {
  LuRefreshCw
} from "react-icons/lu";

import { navigation } from '../utils/Navigation';

const iconMap = {
  MdDashboard, AiOutlineProfile, AiFillLock, MdOutlinePendingActions, MdOutlineVerifiedUser,
  GoUnverified, MdOutlineLeaderboard, LiaSellsy, FaUsers, FaRegUser, RiShieldUserFill,
  GrDocumentConfig, MdOutlineLanguage, IoNewspaperOutline, GrCurrency, IoSettingsOutline,
  VscFileSubmodule, MdTaskAlt, MdOutlineShoppingBag, MdCategory, MdOutlineInventory,
  MdSupportAgent, MdGroupWork, VscChecklist, IoPaperPlaneOutline, BsClipboard2,
  RiOrganizationChart, RiUserStarLine, MdHistory, MdOutlineFeedback, FaLink,
  PiNotebookLight, MdCardMembership, MdCabin, CiBadgeDollar, MdLocationPin, LuRefreshCw
};

export default function AppSidebar() {
  const location = useLocation();
  const [navItems, setNavItems] = useState([]);
  const [collapsed, setCollapsed] = useState({});

  useEffect(() => {
    const fetchNavItems = async () => {
      try {
        setNavItems(navigation);
      } catch (error) {
        console.error("Error fetching navigation items:", error);
      }
    };

    fetchNavItems();
  }, []);

  const isActive = (item) => {
    if (item.link && (location.pathname === item.link || location.pathname.startsWith(item.link))) {
      return true;
    }

    if (item.subItems) {
      return item.subItems.some(subItem => isActive(subItem));
    }

    return false;
  };

  const renderMenuItems = (items, parentKey = '') => {
    return (
      <ul className="nav flex-column">
        {items.map((item, index) => {
          const hasSubItems = item.subItems && item.subItems.length > 0;
          const id = `sidebar-${(parentKey + item.label).replace(/\s+/g, '-')}`;

          return (
            <li className="nav-item" key={id}>
              {hasSubItems ? (
                <>
                  <NavLink
                    className={`nav-link ${isActive(item) ? 'active' : ''}`}
                    to="#"
                    role="button"
                    data-bs-toggle="collapse"
                    aria-expanded={collapsed[id] || isActive(item) ? "true" : "false"}
                    aria-controls={id}
                    onClick={() =>
                      setCollapsed(prev => ({
                        ...prev,
                        [id]: !prev[id],
                      }))
                    }
                  >
                    {iconMap[item.icon] && React.createElement(iconMap[item.icon], {
                      style: { fontSize: '20px', marginRight: '10px' }
                    })}
                    {item.label}
                  </NavLink>
                  <div className={`collapse ${collapsed[id] || isActive(item) ? 'show' : ''}`} id={id}>
                    {renderMenuItems(item.subItems, parentKey + item.label)}
                  </div>
                </>
              ) : (
                <NavLink
                  className={`nav-link ${location.pathname === item.link ? 'active' : ''}`}
                  to={item.link}
                >
                  {iconMap[item.icon] && React.createElement(iconMap[item.icon], {
                    style: { fontSize: '20px', marginRight: '10px' }
                  })}
                  {item.label}
                </NavLink>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div data-bs-theme="">
      <nav className="navbar navbar-vertical fixed-start navbar-expand-md" id="sidebar">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarCollapse"
          aria-controls="sidebarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <NavLink className="navbar-brand" to="/dashboard">
          <img src={logo} className="navbar-brand-img mx-auto" alt="Logo" />
        </NavLink>

        <div className="collapse navbar-collapse" id="sidebarCollapse">
          <ul className="navbar-nav">
            {renderMenuItems(navItems)}
          </ul>
        </div>
      </nav>
    </div>
  );
}
